import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * RightPanel
 * ==========
 *
 * Container do conteúdo à direita do drawer. Ocupa todo o espaço restante
 * no flex container do Dashboard.
 *
 * IMPORTANTE — não precisa de `marginLeft` ou `calc(100% - drawerW)`:
 *
 * - Em DESKTOP, o `<Drawer variant="permanent">` renderiza `.MuiDrawer-docked`
 *   com `flex-shrink: 0` + width definida (280px ou 72px). Esse root reserva
 *   espaço no flex automaticamente. O paper interno é position fixed e segue
 *   o root visualmente. Logo, o RightPanel só precisa `flexGrow: 1` e ocupa
 *   o resto natural do flex.
 *
 * - Em MOBILE, o `<Drawer variant="temporary">` é um Modal — não ocupa espaço
 *   no flex. O RightPanel preenche 100% naturalmente.
 *
 * Se duplicarmos com `marginLeft: drawerW` o conteúdo é empurrado DUAS vezes
 * e estoura pra direita (overflow).
 *
 * `minWidth: 0` garante que conteúdo interno largo (tabelas, etc) não force
 * o flex item a crescer além do espaço disponível.
 */
function RightPanel({ drawerOpen, children }) {
  const theme = useTheme();

  return (
    <Box sx={{ flexGrow: 1,
        minWidth: 0,
        width: 'auto',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: drawerOpen
            ? theme.transitions.duration.enteringScreen
            : theme.transitions.duration.leavingScreen,
        }), }}>
      {children}
    </Box>
  );
}

export default React.memo(RightPanel);
